import Api from "@/axios/api";

export class FailedSendsService {
  static async getFailedActions() {
    const { data } = await Api.get('/customer/customer-automations/failed-actions');
    return data;
  }

  static async postCalculatePrices(payload) {
   return await Api.post(
      '/customer/customer-automations/failed-actions/calculate',
      payload
    );
  }

  static async postFailedActions(payload) {
    return await Api.post('/customer/customer-automations/failed-actions/run', payload);
  }

  static async postDismissActions(payload) {
    return await Api.post('/customer/customer-automations/failed-actions/dismiss', payload);
  }
}
